import type { App } from 'vue'
import AppButton from './app-button.vue'
import AppErrorMsg from './app-error-msg.vue'
import AppLoadingDot from './app-loading-dot.vue'
import AppNotice from './app-notice.vue'
import AppPagination from './app-pagination.vue'
import AppRouterView from './app-router-view.vue'
import AppSelect from './app-select.vue'
import AppTable from './app-table.vue'
import Dropdown from './dropdown'
import FaIcon from './fa-icon.vue'
import Input from './input'
import Modal from './modal'

export default {
  install (app: App) {
    app.component('AppButton', AppButton)
    app.component('AppErrorMsg', AppErrorMsg)
    app.component('AppLoadingDot', AppLoadingDot)
    app.component('AppNotice', AppNotice)
    app.component('AppPagination', AppPagination)
    app.component('AppRouterView', AppRouterView)
    app.component('AppSelect', AppSelect)
    app.component('AppTable', AppTable)

    app.component('FaIcon', FaIcon)

    app.use(Input)
    app.use(Modal)
    app.use(Dropdown)
  },
}

declare module '@vue/runtime-core' {
  export interface GlobalComponents {
    AppButton: typeof AppButton,
    AppErrorMsg: typeof AppErrorMsg,
    AppLoadingDot: typeof AppLoadingDot,
    AppNotice: typeof AppNotice,
    AppPagination: typeof AppPagination,
    AppRouterView: typeof AppRouterView,
    AppSelect: typeof AppSelect,
    AppTable: typeof AppTable,
    FaIcon: typeof FaIcon,
  }
}
